import { makeStyles } from '@material-ui/styles'

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(3),
  },
  results: {
    marginTop: theme.spacing(3),
  },
  alert: {
    marginBottom: theme.spacing(3),
  },
  dividerTitle: {
    marginBottom: theme.spacing(2),
  },
  carregando: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: 20,
  },
  formGroup: {
    padding: theme.spacing(2),
  },
  fieldGroup: {
    padding: theme.spacing(2),
  },
  fieldHint: {
    margin: theme.spacing(1, 0),
  },
  tags: {
    marginTop: theme.spacing(1),
    '& > * + *': {
      marginLeft: theme.spacing(1),
    },
  },
  flexGrow: {
    flexGrow: 1,
  },
  dateField: {
    '& + &': {
      marginLeft: theme.spacing(2),
    },
  },
  buttons: {
    display: 'flex', flexDirection: 'row', flexWrap: 'wrap', gap: '12px', justifyContent: 'space-between', alignItems: 'center'
  },
  modal: {
    display: 'flex',
    alignItems: 'center',

    justifyContent: 'space-between',
    width: '100%',

  },
  paper: {
    width: '50%',
    backgroundColor: theme.palette.background.paper,
    border: '2px solid #000',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
  botoesFormulario: {
    marginTop: theme.spacing(5),
  },
  backButton: {
    backgroundColor: '#9E1A1A',
    color: 'white',
    float: 'right',
    marginRight: '10px'
  },
  divTitulo: {
    borderBottom: 'thin solid #DDD',
  },
}))

export default useStyles
